import { useChatStore } from "@/entities/chat";
import { useMessagesStore } from "@/entities/message";
import { useRef, useEffect } from "react";

export const useSaveDrafts = () => {
  const { currentChat } = useChatStore();
  const { inputTitle } = useMessagesStore();

  const prevChatRef = useRef<typeof currentChat | null>(null);

  useEffect(() => {
    const prevChat = prevChatRef.current;

    if (prevChat) {
      const timer = setTimeout(() => {
        useChatStore.setState((state) => ({
          chats: state.chats.map((chat) => {
            const draft = inputTitle[chat._id];
            const draftMessage =
              draft && draft.text.trim() !== "" ? draft : null;

            return { ...chat, draftMessage };
          }),
        }));
      }, 1000);

      return () => clearTimeout(timer);
    }

    prevChatRef.current = currentChat ?? null;
  }, [currentChat]);
};
